// import React from 'react';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
// import useForm from 'react-hook-form';
import classNames from 'classnames';

import { UserRegister } from '../../Redux/Actions/UserAction';
import TermsModal from '../common/Modal/TermsModal ';
import { useTranslation } from 'react-i18next';
import GoogleLogin from '../common/GoogleLogin';
import { GOOGLE_LOGIN_ENABLED } from '../../config/api';

const Register = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const [user, setUser] = useState({
    username: '',
    mobileNumber: '',
    password: '',
    confirmPassword: '',
    countryCode: '+965',
    userType: 'user',
  });
  const [submitted, setSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const dispatch = useDispatch();

  function handleChange(e) {
    const { name, value } = e.target;
    setUser((user) => ({ ...user, [name]: value }));
  }

  function RegSubmit(e) {
    setSubmitted(true);

    if (
      user.username === '' ||
      user.mobileNumber === '' ||
      user.password === '' ||
      user.confirmPassword === '' ||
      user.countryCode === ''
    ) {
      Swal.fire({
        title: t('Please fill in all required fields'),
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      });
    } else if (user.password !== user.confirmPassword) {
      Swal.fire({
        title: t('Passwords do not match'),
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      });
    } else {
      const { confirmPassword, ...userData } = user;
      dispatch(UserRegister({ ...userData, firstName: userData.username }));
    }
    return false;
  }

  const [showTerms, setShowTerms] = useState(false);

  const handleCloseTerms = () => {
    setShowTerms(false);
  };

  const handleAcceptTerms = () => {
    document.getElementById('inlineCheckbox1').checked = true;
    setShowTerms(false);
  };

  return (
    <div class="login-reg-area">
      <div class="container">
        <div class="login-reg-wrap">
          <h1 class="mb-5">{t('Register')}</h1>

          <form onSubmit={handleSubmit(RegSubmit)}>
            <div class="form-group">
              <label for="reg-fn" class="sr-only">
                {t('Username')}
              </label>
              <input
                {...register('username', {
                  required: t('This field is required'),
                  minLength: {
                    value: 6,
                    message: t('Username must be at least 6 characters'),
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9]{6,30}$/,
                    message: t(
                      'Username must be 6-30 characters, using only letters and numbers'
                    ),
                  },
                })}
                name="username"
                type="text"
                value={user.username}
                onChange={handleChange}
                className={classNames('form-control', {
                  'is-invalid': errors.username,
                })}
                id="reg-fn"
                placeholder={t('Username')}
              />
              {errors.username && (
                <p className="invalid-feedback">{errors.username.message}</p>
              )}
            </div>
            <div class="form-group">
              {/* <label for="g-mb-phone-number">Phone Number</label>  */}
              {/* [CF 2026-08-17 G6] Client: "the country calling code should be
                  displayed on the left side of the phone number". The code sits
                  in the FIRST column, so in Arabic the row mirrored and pushed it
                  to the right of the number. A phone number reads left-to-right
                  in any language, so the row itself is pinned to LTR — code on
                  the left, number beside it, identically in both languages. */}
              <div class="row" dir="ltr">
                <div class="col-3 ml-0  mr-0">
                  <select
                    className={classNames('form-control', {
                      'is-invalid': errors.countryCode,
                    })}
                    name="countryCode"
                    value={user.countryCode}
                    onChange={handleChange}
                    {...register('countryCode', {
                      required: t('This field is required'),
                      validate: (value) =>
                        value !== 'Country Code' ||
                        t('Please select a valid country code'),
                    })}
                    disabled
                  >
                    <option value="Country Code">Country Code</option>
                    <option value="+965">+965</option>
                    <option value="+966">+966</option>
                    <option value="+967">+967</option>
                    <option value="+968">+968</option>
                    <option value="+969">+969</option>
                  </select>

                  {errors.countryCode && (
                    <p className="invalid-feedback">
                      {errors.countryCode.message}
                    </p>
                  )}
                </div>
                <div class="col-9">
                  <input
                    {...register('mobileNumber', {
                      required: 'This field is required',
                      pattern: {
                        value: /^\d{8}$/,
                        message: t('Please enter a valid 8-digit phone number'),
                      },
                    })}
                    type="tel"
                    inputMode="numeric"
                    name="mobileNumber"
                    value={user.mobileNumber}
                    onChange={handleChange}
                    className={classNames('form-control', {
                      'is-invalid': errors.mobileNumber,
                    })}
                    id="g-mb-phone-number"
                    placeholder={t('Phone Number')}
                  />
                  {errors.mobileNumber && (
                    <p className="invalid-feedback">
                      {errors.mobileNumber.message}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div class="form-group" style={{ position: 'relative' }}>
              <label for="reg-password" class="sr-only">
                Password
              </label>
              <input
                {...register('password', {
                  required: t('This field is required'),
                  minLength: {
                    value: 8,
                    message: t('Password must have at least 8 characters'),
                  },
                  pattern: {
                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/,
                    message: t('Password must include uppercase, lowercase, number, and special character'),
                  },
                })}
                name="password"
                type={showPassword ? "text" : "password"}
                value={user.password}
                onChange={handleChange}
                className={classNames('form-control', {
                  'is-invalid': errors.password,
                })}
                id="reg-password"
                placeholder={t('Password')}
                style={{ paddingRight: '40px', backgroundImage: 'none' }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  /* [CF 2026-08-17] Was top:50% + translateY(-50%). That 50% is
                     of the whole .form-group, which holds the input AND the
                     validation message below it — so the moment a password error
                     appeared the group grew and the eye slid down onto the
                     field's bottom edge. Login, Reset Password and Edit Profile
                     all already pin it at 12px (half of a 38px control minus the
                     icon), so this now matches them and cannot drift. */
                  top: '12px',
                  cursor: 'pointer',
                  zIndex: 10,
                }}
              >
                <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
              </span>
              {errors.password && (
                <p className="invalid-feedback">{errors.password.message}</p>
              )}
            </div>

            <div class="form-group" style={{ position: 'relative' }}>
              <label for="reg-con-password" class="sr-only">
                {t('Confirm Password')}
              </label>
              <input
                {...register('confirmPassword', {
                  required: t('This field is required'),
                  validate: (value) =>
                    value === user.password || t('Passwords do not match'),
                })}
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                value={user.confirmPassword}
                onChange={handleChange}
                className={classNames('form-control', {
                  'is-invalid': errors.confirmPassword,
                })}
                id="reg-con-password"
                placeholder={t('Confirm Password')}
                style={{ paddingRight: '40px', backgroundImage: 'none' }}
              />
              <span
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  /* [CF 2026-08-17] Was top:50% + translateY(-50%). That 50% is
                     of the whole .form-group, which holds the input AND the
                     validation message below it — so the moment a password error
                     appeared the group grew and the eye slid down onto the
                     field's bottom edge. Login, Reset Password and Edit Profile
                     all already pin it at 12px (half of a 38px control minus the
                     icon), so this now matches them and cannot drift. */
                  top: '12px',
                  cursor: 'pointer',
                  zIndex: 10,
                }}
              >
                <i className={showConfirmPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
              </span>
              {errors.confirmPassword && (
                <p className="invalid-feedback">
                  {errors.confirmPassword.message}
                </p>
              )}
            </div>

            <div class="form-group">
              {/* [CF 2026-08-17] Bootstrap positions .form-check-input with a
                  negative LEFT margin, which is a physical direction — so on the
                  Arabic site the box was pulled straight onto the label text
                  instead of sitting beside it. Laying the row out with flex and
                  a logical inline-end gap puts the box on the leading edge in
                  both languages: left of the text in English, right of it in
                  Arabic. */}
              <div
                class="form-check form-check-inline"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: 0,
                  margin: 0,
                }}
              >
                <input
                  {...register('terms', {
                    required: t('You must accept the terms and conditions'),
                  })}
                  className={classNames('form-check-input', {
                    'is-invalid': errors.terms,
                  })}
                  type="checkbox"
                  id="inlineCheckbox1"
                  value="option1"
                  name="terms"
                  style={{
                    position: 'static',
                    float: 'none',
                    margin: 0,
                    marginInlineEnd: '8px',
                    flex: '0 0 auto',
                    cursor: 'pointer',
                  }}
                />

                <label
                  class="form-check-label"
                  for="inlineCheckbox1"
                  style={{ margin: 0, cursor: 'pointer' }}
                >
                  {t('Accept')}{' '}
                  <a href="javascript:void(0);" onClick={() => setShowTerms(true)} style={{ textDecoration: 'underline' }}>
                    {t('terms and conditions')}
                  </a>
                </label>
                {errors.terms && (
                  <p className="invalid-feedback" style={{ display: 'block' }}>{errors.terms.message}</p>
                )}
              </div>
            </div>
            <TermsModal
              show={showTerms}
              handleClose={handleCloseTerms}
              handleAccept={handleAcceptTerms}
            />

            <button
              class="btn btn-warning btn-block"
              type="submit"
            >
              {t('Register')}
            </button>

            {GOOGLE_LOGIN_ENABLED && (
              <div class="row justify-content-center no-gutters mt-4">
                <div class="col-12">
                  <GoogleLogin />
                </div>
              </div>
            )}

            <hr class="mt-4 mb-4" />

            <p class="mb-0 text-center">
              {t('Already have an account?')}{' '}
              <Link to="/login">{t('Login')}</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
